import { RootState } from 'reduxStore/types';

export const getModerationRequestStatus = (state: RootState) =>
  state?.moderationRequest.isFormDisabled;
